import { useCallback } from 'react';

import useEnum from '@hooks/useEnum';

import ProcessoService from '@services/ProcessoService';

const useDECriterios = () => {
    const fetch = useCallback(() => ProcessoService.listarDocumentoEnvioCriterios(), []);
    const { data, loading, error } = useEnum(fetch);

    return { data, loading, error };
}

export default useDECriterios;